import React from "react";
import { useState } from "react";

import { useListManager } from "../../contexts/list.manager";
import Button from "../Button/Button";
import Loader from "../Loader/Loader";
import ModalComponent from "../Modal/ModalComponent";
import "./SyncButton.css";
import { MdOutlineSync } from "react-icons/md";
import MqttService from "../../services/MqttService";
import { useTranslation } from "react-i18next";

const SyncButton = (props) => {
  const [showLoader, setShowLoader] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [hideButtons, setHideButtons] = useState(false);

  const { closeForm } = useListManager();
  const { t } = useTranslation();

  const handleClickResync = async () => {
    setModalIsOpen(true);
  };

  const handleConfirm = async () => {
    setShowLoader(true);
    setHideButtons(true);

    if (props.type === "accessPoint") {
      await MqttService.sendResyncAll({
        origin: "frontEnd",
        content: { id_condominium: props.selectedCondominio },
        action: "resyncAllAccess",
      });
    }

    if (props.type === "groups") {
      await MqttService.sendResyncAll({
        origin: "frontEnd",
        content: { id_condominium: props.selectedCondominio },
        action: "resyncAllGroups",
      });
    }

    if (props.type === "unit") {
      await MqttService.sendResyncAll({
        origin: "frontEnd",
        content: { id_condominium: props.selectedCondominio },
        action: "resyncAllUnits",
      });
    }

    if (props.type === "condoUser") {
      await MqttService.sendResyncAll({
        origin: "frontEnd",
        content: { id_condominium: props.selectedCondominio },
        action: "resyncAllCondoUsers",
      });
    }

    const timeout = setTimeout(() => {
      setShowLoader(false);
      setModalIsOpen(false);
      clearTimeout(timeout);
      setHideButtons(false);
      closeForm(true);
    }, 5000);
  };

  const handleCancel = async () => {
    setModalIsOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        className="button-white sync-button"
        label={t("sync.syncAll")}
        onClick={handleClickResync}
        icon={<MdOutlineSync size={20} />}
      />

      <ModalComponent
        modalIsOpen={modalIsOpen}
        modalText={t("sync.dataSynchronization")}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        hideButtons={hideButtons}
      >
        {!showLoader && (
          <div>
            <h1
              style={{
                fontWeight: "bold",
                lineHeight: "15px",
              }}
            >
              {t("sync.confirmSyncAll")}
              <br />
            </h1>
          </div>
        )}

        {showLoader && (
          <div>
            <h1 style={{ fontWeight: "bold" }}>
              {t("sync.syncingDataWithEquipment")}
            </h1>

            <div style={{ marginTop: "-60px" }}>
              <Loader />
            </div>
          </div>
        )}
      </ModalComponent>
    </React.Fragment>
  );
};

export default SyncButton;